import React, { useState } from "react";
import {
    Container,
    TextField,
    Checkbox,
    FormControlLabel,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Typography,
    Paper,
    MenuItem,
    Select,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const EventConstructor = () => {
    const [eventData, setEventData] = useState({
        _id: "f3a70ba5-1d03-475c-acdb-6fa78ef08789",
        event: {
            name: "Jokers CUP 2025",
            value: "jokers_cup_2025",
            lock: false,
        },
        dancesList: ["Boogie-Woogie", "Lindy Hop", "Solo Jazz", "Balboa"],
        categoriesList: {},
        classList: {},
        roundList: {},
        JudgingList: {},
    });

    const [newDance, setNewDance] = useState("");
    const [newCategory, setNewCategory] = useState("");
    const [selectedDance, setSelectedDance] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [newClass, setNewClass] = useState("");

    const handleEventChange = (field, value) => {
        setEventData({
            ...eventData,
            event: { ...eventData.event, [field]: value },
        });
    };

    const handleDanceAdd = () => {
        if (newDance && !eventData.dancesList.includes(newDance)) {
            setEventData({
                ...eventData,
                dancesList: [...eventData.dancesList, newDance],
                categoriesList: { ...eventData.categoriesList, [newDance]: [] },
                classList: { ...eventData.classList, [newDance]: {} },
                roundList: { ...eventData.roundList, [newDance]: {} },
                JudgingList: { ...eventData.JudgingList, [newDance]: {} },
            });
            setNewDance("");
        }
    };

    const handleDanceRemove = (dance) => {
        const updatedCategories = { ...eventData.categoriesList };
        delete updatedCategories[dance];
        const updatedClasses = { ...eventData.classList };
        delete updatedClasses[dance];
        const updatedRounds = { ...eventData.roundList };
        delete updatedRounds[dance];
        const updatedJudging = { ...eventData.JudgingList };
        delete updatedJudging[dance];
        setEventData({
            ...eventData,
            dancesList: eventData.dancesList.filter((d) => d !== dance),
            categoriesList: updatedCategories,
            classList: updatedClasses,
            roundList: updatedRounds,
            JudgingList: updatedJudging,
        });
    };

    const handleCategoryAdd = () => {
        if (selectedDance && newCategory) {
            setEventData({
                ...eventData,
                categoriesList: {
                    ...eventData.categoriesList,
                    [selectedDance]: [...(eventData.categoriesList[selectedDance] || []), { name: newCategory, isPair: false }],
                },
                classList: {
                    ...eventData.classList,
                    [selectedDance]: { ...eventData.classList[selectedDance], [newCategory]: [] },
                },
            });
            setNewCategory("");
        }
    };

    const handleClassAdd = () => {
        if (selectedDance && selectedCategory && newClass) {
            setEventData({
                ...eventData,
                classList: {
                    ...eventData.classList,
                    [selectedDance]: {
                        ...eventData.classList[selectedDance],
                        [selectedCategory]: [...(eventData.classList[selectedDance]?.[selectedCategory] || []), newClass],
                    },
                },
            });
            setNewClass("");
        }
    };

    return (
        <Container  margin={"10px"}  sx={{
            margin: "auto",
            mt: 0,
            ml:1,
            mr:1,
            p: 0,
            overflow: 'auto',
            height: (window.innerHeight - 50) + 'px'}}>
            <Paper sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Event Details</Typography>
                <TextField label="Event Name" fullWidth margin="normal" value={eventData.event.name} onChange={(e) => handleEventChange("name", e.target.value)} />
                <TextField label="Event Value" fullWidth margin="normal" value={eventData.event.value} onChange={(e) => handleEventChange("value", e.target.value)} />
                <FormControlLabel control={<Checkbox checked={eventData.event.lock} onChange={(e) => handleEventChange("lock", e.target.checked)} />} label="Lock Event" />
            </Paper>

            <Paper sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Dances</Typography>
                <List>
                    {eventData.dancesList.map((dance) => (
                        <ListItem key={dance}>
                            <ListItemText primary={dance} />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" onClick={() => handleDanceRemove(dance)}>
                                    <DeleteIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
                <TextField label="New Dance" fullWidth margin="normal" value={newDance} onChange={(e) => setNewDance(e.target.value)} />
                <Button startIcon={<AddIcon />} onClick={handleDanceAdd}>Add Dance</Button>
            </Paper>

            <Paper sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Categories</Typography>
                <Select fullWidth value={selectedDance} onChange={(e) => setSelectedDance(e.target.value)} displayEmpty>
                    <MenuItem value="" disabled>Select Dance</MenuItem>
                    {eventData.dancesList.map((dance) => (<MenuItem key={dance} value={dance}>{dance}</MenuItem>))}
                </Select>
                <TextField label="New Category" fullWidth margin="normal" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} />
                <Button startIcon={<AddIcon />} onClick={handleCategoryAdd}>Add Category</Button>
            </Paper>

            <Paper sx={{ padding: 2, marginBottom: 2 }}>
                <Typography variant="h6">Classes</Typography>
                <Select fullWidth value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} displayEmpty>
                    <MenuItem value="" disabled>Select Category</MenuItem>
                    {selectedDance && eventData.categoriesList[selectedDance]?.map((category, index) => (
                        <MenuItem key={index} value={category.name}>{category.name}</MenuItem>
                    ))}
                </Select>
                <TextField label="New Class" fullWidth margin="normal" value={newClass} onChange={(e) => setNewClass(e.target.value)} />
                <Button startIcon={<AddIcon />} onClick={handleClassAdd}>Add Class</Button>
            </Paper>
        </Container>
    );
};

export default EventConstructor;
